import { CollectionItemSubtitle } from "@/components/collection-item-subtitle/collection-item-subtitle";
import { CollectionObservable } from "@/store/collections/CollectionObservable";
import { observer } from "mobx-react-lite";

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const CollectionItemSubtitleContainer = observer(function CollectionItemSubtitleContainer({
  itemTypeName,
  collection,
}: {
  itemTypeName?: string;
  collection: CollectionObservable;
}) {
  const sizeData = collection.itemList.sizeData;
  const description = collection.description;
  return (
    <CollectionItemSubtitle
      sizeData={sizeData}
      itemTypeName={itemTypeName}
      description={description}
    />
  );
});
